import React from 'react';
import ReactDOM from 'react-dom';
import { initLogging } from 'services/logging';
import { RootProviders } from 'context';
import { TokenMigration } from 'services/chrome';
import { ToastContainer as Toast } from 'react-toastify';
import { App } from './App';

import 'normalize.css';
import 'emoji-mart/css/emoji-mart.css';
import 'styles/global.scss';
import 'react-toastify/dist/ReactToastify.css';

import 'services/i18n/config';

initLogging();

ReactDOM.render(
  <TokenMigration>
    <RootProviders>
      <App />
      <Toast />
    </RootProviders>
  </TokenMigration>,
  document.getElementById('root')
);
